/* global Blob */

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const exportTableToExcel = (tableId, filename = "Urenregistratie.xlsx") => {
  const table = document.getElementById(tableId);
  const workbook = XLSX.utils.table_to_book(table, {
    sheet: "Urenregistratie",
  });
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, filename);
};

export default exportTableToExcel;



// WEBPACK FOOTER //
// ./src/helpers/export-table-to-excel.js